module.exports = __webpack_public_path__ + "static/iraivan-0-b831424006b3bd3586f227015a0d5efd.jpg";